import React, { FunctionComponent, useState } from "react";
import { Box, IconButton, TextField } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import { colorGrayLight, grayscaleGrayDark } from "../../styles/theme";

interface QuestionInputProps {
	disabled: boolean;
	onSend: (question: string) => void;
}

const QuestionInput: FunctionComponent<QuestionInputProps> = ({
	disabled,
	onSend,
}) => {
	const [question, setQuestion] = useState("");

	const handleSend = () => {
		if (!question.trim()) return;
		onSend(question);
		setQuestion("");
	};

	return (
		<Box
			sx={{
				padding: "12px 16px",
				borderTop: `1px solid ${colorGrayLight}`,
				display: "flex",
				gap: "8px",
				alignItems: "flex-end",
			}}
		>
			<TextField
				fullWidth
				multiline
				maxRows={3}
				size="small"
				placeholder="Type your question…"
				value={question}
				disabled={disabled}
				sx={{
					"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
						{
							borderColor: grayscaleGrayDark,
						},
				}}
				onChange={(e) => setQuestion(e.target.value)}
				onKeyDown={(e) => {
					if (e.key === "Enter" && !e.shiftKey) {
						e.preventDefault();
						handleSend();
					}
				}}
			/>
			<IconButton
				disabled={disabled || !question.trim()}
				onClick={handleSend}
				sx={{ color: grayscaleGrayDark }}
			>
				<SendIcon />
			</IconButton>
		</Box>
	);
};

export default QuestionInput;
